import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { QueryService } from '@ngneat/query';
import { Analytics } from '../types';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly _queryService = inject(QueryService);
  private readonly _httpClient = inject(HttpClient);

  queryAnalytics() {
    return this._queryService.use(['analytics'], () => {
      return this._httpClient.get<Analytics>(`/api/globals/analytics`);
    });
  }
}
